import { RouteObject } from 'react-router-dom';
import { MaintenanceGuard } from '../MaintenanceGuard';
import NPSLayout from '../components/layout/NPSLayout';
import { CreateGroupContainer } from '../pages/nps/CreateGroupPage';
import { AssignMentorContainer } from '../pages/nps/AssignMentorPage';
import { EditGroupContainer } from '../pages/nps/EditGroupPage';
import { ViewGroupContainer } from '../pages/nps/ViewGroupPage';
import { AddMorePreceptorsContainers } from '../pages/nps/AddMorePreceptorsPage';
import { CreateBatch } from '../pages/nps/CreateOrUpdateBatch/CreateBatch';
import { UpdateBatch } from '../pages/nps/CreateOrUpdateBatch/UpdateBatch';
import { ExamModuleHome } from '../pages/exam-module/Home';
import { Dashboard } from '../pages/exam-module/dashboard';
import {
	GROUPS,
	ASSIGN_MENTOR,
	EDIT_GROUP,
	VIEW_GROUP,
	ADD_MORE_PRECEPTORS,
	CREATE_BATCH,
	EDIT_BATCH,
	EXAM_MODULE_HOME,
	EXAMS_LIST,
	CREATE_EXAM,
	UPDATE_EXAM,
	VIEW_EXAM,
	CENTERS_LIST,
	CREATE_CENTER,
	UPDATE_CENTER,
	VIEW_CENTER,
	ELIGIBLE_CANDIDATES,
	VIEW_CANDIDATES,
	VIEW_HELD_CANDIDATES,
	KANHA_INVITE,
	CREATE_KANHA_BATCH,
	EDIT_KANHA_BATCH,
	KANHA_ELIGIBLE_CANDIDATES,
	SEND_RESULTS_EMAIL,
	SEND_ADMIT_CARD_EMAIL,
	SEND_INVITE_EMAIL,
	SEND_KANHA_INVITE_EMAIL,
	EXAM_REGISTRATION,
} from '../shared/Routes';
import { ExamRegistration } from '../pages/applicant/ExamRegistration';
import { ExamsList } from '../pages/exam-module/exams-list';
import { CreateExam } from '../pages/exam-module/exams-list/create-update-view-exam/CreateExam';
import { UpdateExam } from '../pages/exam-module/exams-list/create-update-view-exam/UpdateExam';
import { ViewExam } from '../pages/exam-module/exams-list/create-update-view-exam/ViewExam';
import { CentersList } from '../pages/exam-module/centers-list';
import { CreateCenter } from '../pages/exam-module/centers-list/create-update-view-center/CreateCenter';
import { UpdateCenter } from '../pages/exam-module/centers-list/create-update-view-center/UpdateCenter';
import { ViewCenter } from '../pages/exam-module/centers-list/create-update-view-center/ViewCenter';
import { EligibleCandidates } from '../pages/exam-module/eligible-candidates';
import { ViewCandidates } from '../pages/exam-module/view-candidates';
import { ViewHeldCandidates } from '../pages/exam-module/held-candidates';
import { ViewKanhaInviteBatches } from '../pages/exam-module/kanha-invite/batches-list';
import { AddorEditKanhaBatch } from '../pages/exam-module/kanha-invite/batches-list/AddorEditKanhaBatch';
import { KanhaEligibleCandidates } from '../pages/exam-module/kanha-invite/eligible-candidates';
import { SendResultsEmail } from '../pages/exam-module/view-candidates/SendResultsEmail';
import { SendAdmitCardEmail } from '../pages/exam-module/view-candidates/SendAdmitCardEmail';
import { SendInviteEmail } from '../pages/exam-module/eligible-candidates/SendInviteEmail';
import { SendKanhaInviteEmail } from '../pages/exam-module/kanha-invite/eligible-candidates/SendKanhaInviteEmail';

export const NPSRoutes: RouteObject[] = [
	{
		element: <MaintenanceGuard component={<NPSLayout />} />,
		children: [
			{
				path: EXAM_REGISTRATION,
				element: <MaintenanceGuard component={<ExamRegistration />} />,
			},
			{
				path: GROUPS,
				element: <MaintenanceGuard component={<CreateGroupContainer />} />,
			},
			{
				path: ASSIGN_MENTOR,
				element: <MaintenanceGuard component={<AssignMentorContainer />} />,
			},
			{
				path: EDIT_GROUP,
				element: <MaintenanceGuard component={<EditGroupContainer />} />,
			},
			{
				path: VIEW_GROUP,
				element: <MaintenanceGuard component={<ViewGroupContainer />} />,
			},
			{
				path: ADD_MORE_PRECEPTORS,
				element: (
					<MaintenanceGuard component={<AddMorePreceptorsContainers />} />
				),
			},
			{
				path: CREATE_BATCH,
				element: <MaintenanceGuard component={<CreateBatch />} />,
			},
			{
				path: EDIT_BATCH,
				element: <MaintenanceGuard component={<UpdateBatch />} />,
			},
			{
				path: EXAM_MODULE_HOME,
				element: <MaintenanceGuard component={<ExamModuleHome />} />,
				children: [
					{
						index: true,
						element: <MaintenanceGuard component={<Dashboard />} />,
					},
					{
						path: EXAMS_LIST,
						element: <MaintenanceGuard component={<ExamsList />} />,
					},
					{
						path: CREATE_EXAM,
						element: <MaintenanceGuard component={<CreateExam />} />,
					},
					{
						path: UPDATE_EXAM,
						element: <MaintenanceGuard component={<UpdateExam />} />,
					},
					{
						path: VIEW_EXAM,
						element: <MaintenanceGuard component={<ViewExam />} />,
					},
					{
						path: CENTERS_LIST,
						element: <MaintenanceGuard component={<CentersList />} />,
					},
					{
						path: CREATE_CENTER,
						element: <MaintenanceGuard component={<CreateCenter />} />,
					},
					{
						path: UPDATE_CENTER,
						element: <MaintenanceGuard component={<UpdateCenter />} />,
					},
					{
						path: VIEW_CENTER,
						element: <MaintenanceGuard component={<ViewCenter />} />,
					},
					{
						path: ELIGIBLE_CANDIDATES,
						element: <MaintenanceGuard component={<EligibleCandidates />} />,
					},
					{
						path: VIEW_CANDIDATES,
						element: <MaintenanceGuard component={<ViewCandidates />} />,
					},
					{
						path: VIEW_HELD_CANDIDATES,
						element: <MaintenanceGuard component={<ViewHeldCandidates />} />,
					},
					{
						path: KANHA_INVITE,
						element: (
							<MaintenanceGuard component={<ViewKanhaInviteBatches />} />
						),
					},
					{
						path: CREATE_KANHA_BATCH,
						element: <MaintenanceGuard component={<AddorEditKanhaBatch />} />,
					},
					{
						path: EDIT_KANHA_BATCH,
						element: <MaintenanceGuard component={<AddorEditKanhaBatch />} />,
					},
					{
						path: KANHA_ELIGIBLE_CANDIDATES,
						element: (
							<MaintenanceGuard component={<KanhaEligibleCandidates />} />
						),
					},
					{
						path: SEND_RESULTS_EMAIL,
						element: <MaintenanceGuard component={<SendResultsEmail />} />,
					},
					{
						path: SEND_ADMIT_CARD_EMAIL,
						element: <MaintenanceGuard component={<SendAdmitCardEmail />} />,
					},
					{
						path: SEND_INVITE_EMAIL,
						element: <MaintenanceGuard component={<SendInviteEmail />} />,
					},
					{
						path: SEND_KANHA_INVITE_EMAIL,
						element: <MaintenanceGuard component={<SendKanhaInviteEmail />} />,
					},
				],
			},
		],
	},
];
